module.exports = __webpack_public_path__ + "img/la-murga.a7d4b7b2.png";